//Contains original JSON questions
const originalJsonQuestions = [
  {
    label: "Right Knee",
    title: "",
    subMain: "",
    sub: "",
    addServiceConnected: true,
    options: [
      {
        main: "Complete tear repair- Successful",
        dbqName:
          "form1[0].#subform[9].CheckBox37[158],form1[0].#subform[9].#area[67].CheckBox37[156]",
        sub: "",
      },
      {
        main: "Complete tear repair- Failed",
        dbqName:
          "form1[0].#subform[9].CheckBox37[159],form1[0].#subform[9].#area[67].CheckBox37[156]",
        sub: "",
      },
      {
        main: "No",
        dbqName: "form1[0].#subform[9].#area[67].CheckBox37[157]",
        sub: "",
      },
    ],
    answer: "No",
  },
  {
    label: "Left Knee",
    title: "",
    subMain: "",
    sub: "",
    addServiceConnected: true,
    options: [
      {
        main: "Complete tear repair- Successful",
        dbqName:
          "form1[0].#subform[9].CheckBox37[183],form1[0].#subform[9].#area[74].CheckBox37[181]",
        sub: "",
      },
      {
        main: "Complete tear repair- Failed",
        dbqName:
          "form1[0].#subform[9].CheckBox37[184],form1[0].#subform[9].#area[74].CheckBox37[181]",
        sub: "",
      },
      {
        main: "No",
        dbqName: "form1[0].#subform[9].#area[74].CheckBox37[182]",
        sub: "",
      },
    ],
    answer: "No",
  },
];

export const kneeLigamentSkip = (currentQuestions, nextQuestions) => {
  let showRight = true;
  let showLeft = true;

  //Case in which inital bilateral logic already filted the json, we can return early by changing the answer value
  if (currentQuestions.length === 1) {
    const isAnswerNo = currentQuestions[0].answer === "No";
    nextQuestions[0].answer = isAnswerNo ? "" : "No";
    return { skipRef: isAnswerNo ? 1 : 0, nextQuestions };
  }

  //Set the next questions to their original value for later filtering
  nextQuestions = originalJsonQuestions;

  //Determines which side of the questions to show
  for (const question of currentQuestions) {
    const { answer, label } = question;
    if (answer === "No") {
      if (label === "Right Knee") { showRight = false }
      if (label === "Left Knee") { showLeft = false }
    }
  }

  // Return early if we either want to show or skip both right and left sides
  if (showRight && showLeft) {
    return { skipRef: 0, nextQuestions };
  }

  // Return early if we want to skip both right and left sides
  if (!showRight && !showLeft) {
    return { skipRef: 1, nextQuestions: [] };
  }

  //Filters out the json questions that needs to be skipped
  nextQuestions = nextQuestions.filter((question) => {
    if (question.label === "Right Knee" && !showRight) { return false }
    if (question.label === "Left Knee" && !showLeft) { return false }
    return true;
  });

  return { skipRef: 0, nextQuestions };
};
